import { SupplyPosition } from '../../services/supplyService';
import { aggregateToMaterialsDic, aggregateByFormula, MaterialExposureDictionary } from '../../utils/positionUtils';

// Re-export the unified type so existing imports don't break
export type { MaterialExposureDictionary as materialExposureDictionary } from '../../utils/positionUtils';

export const aggregateSupplyPositionsToMaterialsDic = (
  supplyPositions: SupplyPosition[],
  selMaterial?: string,
  materialPriceDic?: Record<string, number>,
  getRateToBase?: (currency: string) => number | null,
): Record<string, MaterialExposureDictionary> => {
  return aggregateToMaterialsDic(supplyPositions, materialPriceDic || {}, selMaterial);
};

// Aggregate supply positions by material for summary cards
export const aggregateSupplyByMaterial = (
  supplyPositions: SupplyPosition[],
  materialPriceDic: Record<string, number>,
  getRateToBase?: (currency: string) => number | null,
): Record<string, { quantity: number; totalValue: number }> => {
  return aggregateByFormula(supplyPositions, materialPriceDic);
};
